import { render } from "./MonitorMessageStatusView.vue?vue&type=template&id=22433d58"
import script from "./MonitorMessageStatusView.vue?vue&type=script&lang=js"
export * from "./MonitorMessageStatusView.vue?vue&type=script&lang=js"

import "./MonitorMessageStatusView.vue?vue&type=style&index=0&id=22433d58&lang=css"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__